import { render, staticRenderFns } from "./changeinfo.vue?vue&type=template&id=547d8cc8&scoped=true&"
import script from "./changeinfo.vue?vue&type=script&lang=js&"
export * from "./changeinfo.vue?vue&type=script&lang=js&"
import style0 from "./changeinfo.vue?vue&type=style&index=0&id=547d8cc8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "547d8cc8",
  null
  
)

export default component.exports